import type { MetricasUsuario } from '@/lib/usuarioExport';

/**
 * Padrão dos gráficos de Usuários > Desempenho/Módulos: barras horizontais com a mesma coluna de
 * nomes, a mesma espessura de barra e a mesma altura por linha, independente de quantos itens.
 */
export const LARGURA_NOMES = 180;
export const MAX_CARACTERES_NOME = 26;
export const ALTURA_LINHA = 32;
export const ESPESSURA_BARRA = 18;

export const alturaGrafico = (linhas: number) => Math.max(3, linhas) * ALTURA_LINHA + 40;

export const nomeCurto = (nome: string) =>
  nome.length > MAX_CARACTERES_NOME ? `${nome.slice(0, MAX_CARACTERES_NOME - 1)}…` : nome;

/** Cores semânticas, as mesmas em todo gráfico: bom / atenção / ruim / sem dado. */
export const COR = {
  bom: '#10b981',
  atencao: '#f59e0b',
  ruim: '#ef4444',
  critico: '#b91c1c',
  neutro: '#94a3b8',
  destaque: 'hsl(217, 91%, 60%)',
} as const;

/** Nomes repetidos (ex: dois "Super Admin") ganham um número pra não ficarem ambíguos. */
export function rotulosUnicos(metricas: MetricasUsuario[]): Map<string, string> {
  const total = new Map<string, number>();
  metricas.forEach((m) => total.set(m.nome, (total.get(m.nome) ?? 0) + 1));
  const vistos = new Map<string, number>();
  const rotulos = new Map<string, string>();
  metricas.forEach((m) => {
    if ((total.get(m.nome) ?? 0) < 2) {
      rotulos.set(m.id, m.nome);
      return;
    }
    const n = (vistos.get(m.nome) ?? 0) + 1;
    vistos.set(m.nome, n);
    rotulos.set(m.id, `${m.nome} (${n})`);
  });
  return rotulos;
}

/** Primeira letra maiúscula — descrições da auditoria vêm em minúscula ("atualizou empresa ..."). */
export const capitalizar = (texto: string) => (texto ? texto.charAt(0).toUpperCase() + texto.slice(1) : texto);

export const haQuantoTempo = (dias: number | null) =>
  dias === null ? 'nunca acessou' : dias === 0 ? 'hoje' : dias === 1 ? 'ontem' : `há ${dias} dias`;
